import AOS from 'aos';

AOS.init({
  once: true,
});

const hamburger = document.querySelector(".hamburger");
if (hamburger) {
	hamburger.addEventListener("click", (e) => {
		document.querySelector(".navigation").classList.toggle('hidden');
		hamburger.querySelector('.icon-close').classList.toggle('opacity-0');
		hamburger.querySelector('.icon-menu').classList.toggle('opacity-0');
	}, false);
}
